// extracted by mini-css-extract-plugin
export var button = "columns-module--button--N7H7X";
export var columnsItem = "columns-module--columnsItem--CTCEy";
export var columnsRow = "columns-module--columnsRow---13ZJ";
export var columnsTwoRow = "columns-module--columnsTwoRow--1S2Ew";
export var divider = "columns-module--divider--ieIis";
export var fontsLoading = "columns-module--fonts-loading--rxXjX";
export var h5 = "columns-module--h5--QcJ8J";
export var icon = "columns-module--icon--AooKK";
export var numberIcon = "columns-module--numberIcon--WCoxD";
export var wrapper = "columns-module--wrapper--Yf4rJ";